import { render } from "./FooterLayout.vue?vue&type=template&id=b02358d6"
const script = {}

import exportComponent from "../../../../../kaicms_vue_250623/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__